import { render, staticRenderFns } from "./testPage.vue?vue&type=template&id=51569b63&"
import script from "./testPage.vue?vue&type=script&lang=js&"
export * from "./testPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports